import { authInstance } from './axios/index';

// 예약 경로의 Long ID만 허용한다. 문자열은 숫자로 변환하지 않아 큰 ID의 정밀도를 보존한다.
export function isValidReservationId(id) {
  if (typeof id === 'number') return Number.isSafeInteger(id) && id > 0;
  return typeof id === 'string' && /^\d+$/.test(id) && /[1-9]/.test(id);
}

// Axios에 전달하기 전에 거절하므로 응답 인터셉터의 오류 토스트나 네트워크 요청이 발생하지 않는다.
export function reservationRequest(id, options) {
  if (!isValidReservationId(id)) {
    const error = new Error('Reservation ID is not available');
    error.code = 'INVALID_RESERVATION_ID';
    return Promise.reject(error);
  }
  return authInstance(options);
}
